export const moveListItems = (componentData) => {
  componentData.list.content.items.forEach((listItem) => {
    const groupIndex = componentData.list.content.groups.findIndex((group) => {
      return group.ID === listItem.groupIndex;
    });
    if (groupIndex == -1) return;
    listItem.groupIndex = groupIndex;
  });
};
